import React from 'react'
import styled from 'styled-components'
import { Popup } from '../../../../../components/Popup'
import ScheduleCalendar from '../../../../../components/ScheduleCalendar'
import '../chapterAddEdit.css'

const GreenLabel = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: var(--lime-100);
  margin-right: 8px;
`
const CalenderBox = styled.div`
  width: 100%;
  height: 312px;
  border-radius: 4px;
  background-color: var(--dove);
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`
const LabelBox = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`
const LabelDesc = styled.div`
  font-size: 12px;
  line-height: 1.33;
  text-align: left;
  color: var(--Text500);
`
const RedLabel = styled(GreenLabel)`
  background-color: var(--crimson-300);
  margin-left: 16px;
`

function calendarPopup({
  calendarPopup,
  setCalendarPopup,
  setUserCalendarDate,
  setSchedulePublishPopup,
  onBackClick,
  schedulerPopup
}) {
  const isMobile = window.screen.width < 600
  return (
    <Popup
      show={schedulerPopup}
      close={() => setCalendarPopup(false)}
      className={isMobile ? 'schedule-calendar-mobile' : 'schedule-calendar'}
    >
      <CalenderBox>
        <ScheduleCalendar
          setUserCalendarDate={setUserCalendarDate}
          close={() => setCalendarPopup(false)}
          openPublishPopup={() => setSchedulePublishPopup(true)}
          onBackClick={onBackClick}
        />
      </CalenderBox>
      <LabelBox>
        <GreenLabel />
        <LabelDesc>Available Dates to Schedule</LabelDesc>
        <RedLabel />
        <LabelDesc>Already Scheduled</LabelDesc>
      </LabelBox>
    </Popup>
  )
}

export default calendarPopup